import { P2GChip } from '@parcel2go/core-ui';

interface props {
  label: string;
  color?: 'primary' | 'secondary' | 'default' | 'success' | 'error' | 'info' | 'danger' | 'warning';
}

export default function Tag(props: props) {
  if (props.label === 'ReturnCollection') {
    return <P2GChip color="primary" size="small" label={'Return Collection'} />;
  }

  return <P2GChip color={props.color || 'primary'} size="small" label={props.label} />;
}
